import React, { useState } from "react";
import PropTypes from "prop-types";

function AddFromPermanentInvitationModal({
  isOpen,
  onClose,
  permanentInvitationLists,
  onAddInvitationsFromList,
}) {
  const [selectedLists, setSelectedLists] = useState([]);

  const handleCheckboxChange = (listId) => {
    setSelectedLists((prevLists) =>
      prevLists.includes(listId)
        ? prevLists.filter((id) => id !== listId)
        : [...prevLists, listId]
    );
  };

  const handleAddInvitations = () => {
    onAddInvitationsFromList(selectedLists);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-4 rounded-lg shadow-lg w-[350px] relative">
        <h2 className="text-lg font-bold mb-3 text-gray-800">Select Invitation Lists</h2>
        
        <div className="max-h-60 overflow-y-auto mb-3">
          {permanentInvitationLists.length === 0 ? (
            <p className="text-gray-500 text-sm">No invitation lists available.</p>
          ) : (
            permanentInvitationLists.map((list) => (
              <div key={list.value} className="mb-2">
                <label className="flex items-center text-sm">
                  <input
                    type="checkbox"
                    className="h-4 w-4 text-indigo-600 mr-2 rounded border-gray-300 focus:ring-indigo-500"
                    value={list.value}
                    checked={selectedLists.includes(list.value)}
                    onChange={() => handleCheckboxChange(list.value)}
                  />
                  {list.label}
                </label>
              </div>
            ))
          )}
        </div>

        <div className="flex justify-center space-x-4">
          <button
            className="px-5 py-1.5 bg-indigo-600 text-white font-medium rounded hover:bg-indigo-700 transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            onClick={handleAddInvitations}
            disabled={selectedLists.length === 0}
          >
            Add Selected
          </button>
          <button
            className="px-5 py-1.5 bg-white text-gray-700 font-medium rounded hover:bg-gray-100 border border-gray-300 transition duration-200 text-sm"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>

        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 transition duration-200"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}

AddFromPermanentInvitationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  permanentInvitationLists: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onAddInvitationsFromList: PropTypes.func.isRequired,
};

export default AddFromPermanentInvitationModal;